// extracted by mini-css-extract-plugin
export default {"search__text":"Search_search__text__AZd2Q","search__status":"Search_search__status__TPoc0","search__btn":"Search_search__btn__ZH2rz"};